import PropTypes from 'prop-types';

export const documentShape = PropTypes.shape({
  verificationComment: PropTypes.string,
  verificationStatus: PropTypes.string,
  documentUploadTime: PropTypes.number.isRequired,
  documentType: PropTypes.string.isRequired,
});
